import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import { Validator } from 'vee-validate'
import createMapping from '../../../Mappings/getCommonFunctionMaps';

export default {
  name: 'login',
  components: {VueElementLoading},
  props: [],
  data() {
    return {
      username: '',
      password: '',
      isLoading:false,
      loginShow:true,
      RedirectionError: ''
    }
  },
  computed: {

  },
  mounted() {
    localStorage.clear();
    let tokenid = this.$route.params.id ? this.$route.params.id : '';
    if(!this.loginShow || tokenid){
      tokenid = this.$route.params.id;
      this.SSOLogin(tokenid);
    }
  },
  methods: {
    SSOLogin(tokenid) {
      this.isLoading = true;
      axios.post(apiUrl.api_url + 'validateuseraccesstoken', {
          'token': tokenid
        })
        .then((response) => {

          if(response.data.code == 200){
            let getResultData = response.data;
           // console.log('getResultData',getResultData);
            let permissionEncrypt = CryptoJS.AES.encrypt(JSON.stringify(getResultData.urlDetails), "Key");
            let usersEncrupt      = CryptoJS.AES.encrypt(JSON.stringify(getResultData.userinfo), "Key");
            let hubEncrypt        = CryptoJS.AES.encrypt(JSON.stringify(getResultData.hubData), "Key");
  
            window.localStorage.setItem('accesspermissiondata', permissionEncrypt);
            window.localStorage.setItem('accessuserdata', usersEncrupt);
            window.localStorage.setItem('isLoggedIn',true);
            window.localStorage.setItem('accessuserToken', response.data.token);
            window.localStorage.setItem('logoutTime', new Date().setHours(new Date().getHours() + 8));
            window.localStorage.setItem('accesshubdata', hubEncrypt);
            window.localStorage.setItem('accessrole', response.data.userinfo.roleid);
            window.localStorage.setItem('userinfo', JSON.stringify(getResultData.userinfo));
            window.localStorage.setItem('username', response.data.userinfo.username);
            window.localStorage.setItem('ActiveModule', 'b2c');
  
            createMapping(response.data.token);
  
            permissionEncrypt           = window.localStorage.getItem('accesspermissiondata')
            let permissiondatabytes     = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
            let permissiondataplaintext = permissiondatabytes.toString(CryptoJS.enc.Utf8);
            let permissiondata          = JSON.parse(permissiondataplaintext);
  
            this.$router.push(permissiondata[0].url); //location.reload(true);
            this.$alertify.success("Logged In Successfully");
  
          }else if(response.data.code == 302){
  
            window.location.href= response.data.redirecturl;
            // this.$alertify.error("Your Password has been Expired! Redirecting to change Password Page!! Page valid for 5 min only!!");
            // this.RedirectionError = 'Password is Expired, Redirecting...';
  
          }else {
            this.$alertify.error(response.data.error);
          }
  
          this.isLoading = false;
        })
        .catch((httpException) => {
          this.isLoading = false;
          console.error('exception is:::::::::', httpException)
        })
    },

     checklogin() {

      //let projectID   = CryptoJS.AES.encrypt('$#@COD&&Mang&*^%$$', "xb-cod-security");
      this.isLoading  = true;
      axios.post(apiUrl.api_url + 'userapp/auth',{
        'username': this.username,
        'password': this.password

      })
      .then((response) => {

        if(response.data.code == 200){
          let getResultData = response.data;
         // console.log('getResultData',getResultData);
          let permissionEncrypt = CryptoJS.AES.encrypt(JSON.stringify(getResultData.urlDetails), "Key");
          let usersEncrupt      = CryptoJS.AES.encrypt(JSON.stringify(getResultData.userinfo), "Key");
          let hubEncrypt        = CryptoJS.AES.encrypt(JSON.stringify(getResultData.hubData), "Key");

          window.localStorage.setItem('accesspermissiondata', permissionEncrypt);
          window.localStorage.setItem('accessuserdata', usersEncrupt);
          window.localStorage.setItem('isLoggedIn',true);
          window.localStorage.setItem('accessuserToken', response.data.token);
          window.localStorage.setItem('logoutTime', new Date().setHours(new Date().getHours() + 8));
          window.localStorage.setItem('accesshubdata', hubEncrypt);
          window.localStorage.setItem('accessrole', response.data.userinfo.roleid);
          window.localStorage.setItem('username', response.data.userinfo.username);
          window.localStorage.setItem('userinfo', JSON.stringify(getResultData.userinfo));
          window.localStorage.setItem('ActiveModule', 'b2c');

          createMapping(response.data.token);

          permissionEncrypt           = window.localStorage.getItem('accesspermissiondata')
          let permissiondatabytes     = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
          let permissiondataplaintext = permissiondatabytes.toString(CryptoJS.enc.Utf8);
          let permissiondata          = JSON.parse(permissiondataplaintext);
          this.$router.push(permissiondata[0].url); //location.reload(true);
          this.$alertify.success("Logged In Successfully")
          // window.localStorage.setItem('accesspermissiondata', '');
          // window.localStorage.setItem('accessuserdata', '');
          // window.localStorage.setItem('isLoggedIn',false);
          // window.localStorage.setItem('accessuserToken', '');
          // window.localStorage.setItem('accessrole', '');
          // window.localStorage.setItem('logoutTime', '');
          // window.localStorage.setItem('accesshubdata', '');
          // window.localStorage.setItem('accesszone', '');
          //
        }else if(response.data.code == 302){

          window.location.href= response.data.redirecturl;
          // this.$alertify.error("Your Password has been Expired! Redirecting to change Password Page!! Page valid for 5 min only!!");
          // this.RedirectionError = 'Password is Expired, Redirecting...';

        }else {
          this.$alertify.error(response.data.error);
        }


        // if(response.data.token && response.data.token!=''){

          // let permissionEncrypt = CryptoJS.AES.encrypt(JSON.stringify(response.data.urlDetails), "Key");
          // let usersEncrupt      = CryptoJS.AES.encrypt(JSON.stringify(response.data.userinfo), "Key");
          // let hubEncrypt        = CryptoJS.AES.encrypt(JSON.stringify(response.data.hubData), "Key");
          //
          // window.localStorage.setItem('accesspermissiondata', permissionEncrypt);
          // window.localStorage.setItem('accessuserdata', usersEncrupt);
          // window.localStorage.setItem('isLoggedIn',true);
          // window.localStorage.setItem('accessuserToken', response.data.token);
          // window.localStorage.setItem('logoutTime', new Date().setHours(new Date().getHours() + 8));
          // window.localStorage.setItem('accesshubdata', hubEncrypt);
          // window.localStorage.setItem('accessrole', response.data.userinfo.rolename);
          //
          // permissionEncrypt           = window.localStorage.getItem('accesspermissiondata')
          // let permissiondatabytes     = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
          // let permissiondataplaintext = permissiondatabytes.toString(CryptoJS.enc.Utf8);
          // let permissiondata          = JSON.parse(permissiondataplaintext);

          // if(response.data.code==200){
          //   this.$router.push(permissiondata[0].url); location.reload(true)
          // }else{ this.$alertify.error(response.data.message); }

        // }else{ this.$alertify.error(response.data.message); }

        this.isLoading = false;
      })
      .catch((httpException) => {
        this.isLoading = false; this.$alertify.error("Logging Failed"); console.error('exception is:::::::::', httpException)
      })
    },

    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){ this.checklogin(); }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },

    resetForm() {
      this.username = this.password = ''; this.isLoading = false;
      this.$validator.reset(); this.errors.clear();
    },

    forgetPassword(){
      window.location.href=process.env.FORGOT_PASSWORD;
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/login/login.component.js